"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var NguiUtilsDirective = (function () {
    function NguiUtilsDirective() {
    }
    return NguiUtilsDirective;
}()); // dummy directive to allow non-standard tags
NguiUtilsDirective = __decorate([
    core_1.Directive({
        selector: 'ngui-utils-1, ngui-utils-2, ngui-utils-3, ngui-utils-4, ngui-utils-5,' +
            'ngui-utils-6, ngui-utils-7, ngui-utils-8, ngui-utils-9, ngui-utils-10,' +
            'ngui-utils-11, ngui-utils-12, ngui-utils-13, ngui-utils-14, ngui-utils-15,' +
            'ngui-utils-16, ngui-utils-17, ngui-utils-18, ngui-utils-19, ngui-utils-20'
    }),
    __metadata("design:paramtypes", [])
], NguiUtilsDirective);
exports.NguiUtilsDirective = NguiUtilsDirective;
//# sourceMappingURL=utils.directive.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngui/infinite-list/~/@ngui/utils/dist/directives/utils.directive.js
// module id = 538
// module chunks = 4